import { formatFromISOString } from "@/utils/date";

export default class BirthDate {
  readonly DATE: string;
  readonly YEAR: number;
  readonly MONTH: number;
  readonly DAY: number;
  constructor(year: number, month: number, day: number) {
    this.DATE = formatFromISOString(
      `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`,
      "yyyy-MM-dd"
    );
    this.YEAR = year;
    this.MONTH = month;
    this.DAY = day;
  }
}

export const defaultBirthDate = new BirthDate(1979, 1, 1);
